import styled, { css } from "styled-components";

import { bettoSelectedSurface } from "../../bettoSelectedSurface";

import chevronRightIcon from "@layouts/betto/assets/chevronRight.svg";
import searchIcon from "@layouts/betto/assets/search.webp";

export const BettoFiltersRoot = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	width: 100%;
	margin-bottom: 28px;

	&& {
		width: 100% !important;
		max-width: 100% !important;
		margin-top: 0 !important;
		padding: 0 !important;
		justify-content: stretch !important;
	}

	&& > div {
		min-width: 0 !important;
		width: 100%;
	}
`;

export const BettoSearchBar = styled.button`
	display: flex;
	align-items: center;
	gap: 4px;
	width: 100%;
	height: 52px;
	padding: 0 14px;
	border-radius: 10px;
	border: 1px solid #343946;

	background: #1f2536;
	cursor: pointer;
	text-align: left;
	transition:
		border-color 0.2s ease,
		background 0.2s ease;

	&:hover {
		border-color: #4a5163;
		background: #252b3d;
	}
`;

export const BettoSearchIcon = styled.img`
	flex-shrink: 0;
	width: 24px;
	height: 24px;
	display: block;
`;

export const BettoSearchPlaceholder = styled.span`
	color: #858faf;
	font-size: 14px;
	font-weight: 400;
	line-height: 1.2;
	display: inline-flex;
	align-items: center;
`;

export const BettoFilterTrack = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	width: 100%;
	height: 46px;
	box-sizing: border-box;
	padding: 4px;
	border-radius: 13px;
	background: #171c2a;
	overflow: hidden;
	isolation: isolate;

	button[data-testid="button-casino-filter-i-feel-lucky"],
	button[data-testid="button-casino-filter-tvbet"],
	button[data-testid="button-casino-filter-favorites"] {
		display: inline-flex !important;
		align-items: center !important;
		justify-content: center;
		gap: 4px;
		box-sizing: border-box !important;
		height: 38px !important;
		min-height: 38px !important;
		width: max-content !important;
		max-width: max-content !important;
		min-width: 0 !important;
		padding: 0 12px !important;
		border: none !important;
		border-radius: 10px !important;
		background: transparent !important;
		color: #abb4cf !important;
		font-size: 14px !important;
		font-weight: 400 !important;
		line-height: 1 !important;
		cursor: pointer;

		&:hover {
			opacity: 1 !important;
			background: #202534 !important;
			color: #e5f0fe !important;
		}

		span {
			display: inline-flex;
			align-items: center;
			line-height: 1;
			white-space: nowrap;
		}

		svg,
		img {
			display: block;
			flex-shrink: 0;
			align-self: center;
		}

		svg {
			width: 14px !important;
			height: 14px !important;
			margin: 0 !important;
		}

		.tvbet-icon {
			width: 44px !important;
			height: 16px !important;
			margin: 0 0 4px 0 !important;
		}
	}
`;

export const BettoFilterScroll = styled.div`
	position: relative;
	z-index: 0;
	display: flex;
	align-items: center;
	flex: 1 1 auto;
	align-self: stretch;
	gap: 8px;
	min-width: 0;
	height: 100%;
	overflow-x: auto;
	overflow-y: hidden;
	scroll-behavior: smooth;
	padding-left: ${({ $hasScrollPaddingLeft }) => ($hasScrollPaddingLeft ? "40px" : "0")};
	padding-right: ${({ $hasScrollPadding }) => ($hasScrollPadding ? "44px" : "0")};
	-ms-overflow-style: none;
	scrollbar-width: none;

	& > * {
		flex: 0 0 auto;
		width: max-content;
		max-width: max-content;
		min-width: 0;
	}

	&::-webkit-scrollbar {
		display: none;
	}
`;

export const BettoFilterPill = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 4px;
	flex: 0 0 auto;
	flex-shrink: 0;
	align-self: center;
	box-sizing: border-box;
	width: max-content;
	max-width: max-content;
	height: 38px;
	padding: 0 12px;
	border: none;
	border-radius: 10px;
	background: transparent;
	color: #abb4cf;
	font-family: inherit;
	font-size: 14px;
	font-weight: 400;
	line-height: 1;
	cursor: pointer;
	white-space: nowrap;
	position: relative;
	isolation: isolate;
	overflow: hidden;
	transition:
		background 0.2s ease,
		color 0.2s ease;

	${({ $active }) =>
		$active &&
		css`
			${bettoSelectedSurface}
		`}

	&:hover:not(:disabled) {
		background: #202534;
		color: #e5f0fe;
	}

	span {
		display: inline-flex;
		align-items: center;
		line-height: 1;
	}

	svg {
		display: block;
		flex-shrink: 0;
		align-self: center;
	}

	.tvbet-icon {
		width: 44px;
		height: 16px;
		flex-shrink: 0;
	}
`;

export const BettoFilterIcon = styled.img`
	flex-shrink: 0;
	align-self: center;
	display: block;
	width: 14px;
	height: 14px;
	object-fit: contain;
	transition: filter 0.2s ease;
`;

export const BettoScrollFade = styled.div`
	position: absolute;
	top: 4px;
	right: 0;
	z-index: 2;
	width: 60px;
	height: 46px;
	background: linear-gradient(270deg, #171c2a 0%, rgba(23, 28, 42, 0) 100%);
	pointer-events: none;
`;

export const BettoScrollFadeLeft = styled(BettoScrollFade)`
	left: 0;
	right: auto;
	background: linear-gradient(90deg, #171c2a 0%, rgba(23, 28, 42, 0) 100%);
`;

export const BettoScrollButton = styled.button`
	position: absolute;
	top: 50%;
	right: 6px;
	z-index: 3;
	width: 34px;
	height: 34px;
	padding: 0;
	border: none;
	border-radius: 10px;
	background: transparent;
	background-image: url(${chevronRightIcon});
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	cursor: pointer;
	transform: translateY(-50%);
	transition:
		opacity 0.2s ease,
		filter 0.2s ease;
	-webkit-appearance: none;
	appearance: none;
	pointer-events: auto;

	&:hover:not(:disabled) {
		filter: brightness(1.08);
	}

	&:disabled {
		opacity: 0.35;
		cursor: default;
	}
`;

export const BettoScrollButtonLeft = styled(BettoScrollButton)`
	left: 6px;
	right: auto;
	transform: translateY(-50%) rotate(180deg);
`;

export { searchIcon };
